import React, { Component } from 'react';

import cn from 'classnames';
import styles from './SpinnerImage.scss';

class SpinnerImage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loadingState: null
    };

    this.handleImageLoad = this.handleImageLoad.bind(this);
    this.handleImageError = this.handleImageError.bind(this);
  }

  handleImageLoad (event) {
    const { handleImageLoad } = this.props;
    this.setState({ loadingState: true }, () => {
      if (handleImageLoad) {
        handleImageLoad(event);
      }
    });
  }

  handleImageError (event) {
    const { handleImageError } = this.props;
    this.setState({ loadingState: false }, () => {
      if (handleImageError) {
        handleImageError(event);
      }
    });
  }

  render() {
    const {
      spinner, placeholder,
      className, style,
      imageSrc, imageAlt, imageClassName,
      blur,
    } = this.props;
    const { loadingState } = this.state;

    return (
      <div className={cn(styles.Container, className)} style={style}>
        {loadingState == null || blur ? spinner : null}
        <div className={cn(styles.BlurContainer, {[styles.BluredContainer]: blur})}>
          {loadingState === false ? placeholder : (
            <img
              className={cn(styles.Image, imageClassName, { [styles.Hidden]: !loadingState })}
              alt={imageAlt}
              src={imageSrc}
              onLoad={this.handleImageLoad}
              onError={this.handleImageError}
            />
          )}
          {loadingState !== null && this.props.children}
        </div>
      </div>
    );
  }
}

export default SpinnerImage;



// WEBPACK FOOTER //
// ./src/components/common/SpinnerImage/SpinnerImage.js